import { Helpers } from '../../helpers';
import { IOilContractStatus } from '../../interfaces/ioil-contract-status';
import { TankBattery } from '../tank-battery';

export class OilContractStatusBase {
  OilContractStatusId: number;
  Description: string | null;
  Abbreviation: string | null;
  SortOrder: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  TankBatteries_OilContractStatus?: Array<TankBattery> | null;

  constructor(item?: IOilContractStatus) {
    if (item) {

      this.OilContractStatusId = item.OilContractStatusId;
      this.Description = item.Description;
      this.Abbreviation = item.Abbreviation;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.TankBatteries_OilContractStatus = Helpers.createClassArray(TankBattery, item.TankBatteries_OilContractStatus);
    }
  }
}